module.exports = __webpack_public_path__ + "static/img/paypal-1.baeb4b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/help/paypal-1.png
// module id = gSVQ
// module chunks = 1